<template>
    <div>
        <el-dialog :visible.sync="upLoaing" :show-close="false">
            <h4>拉卡拉文件{{ vinAccountForm.acctType == 0 ? '对公' : '对私' }}上传</h4>
            <el-form :model="uploag" :rules="uploagRules" ref="uploagRef" label-width="240px">
                <el-form-item label="银行卡号" required>
                    <el-input v-model="uploag.bankCard"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" required>
                    <el-input v-model="uploag.idCardNumber"></el-input>
                </el-form-item>
                <el-form-item label="营业执照号码" required v-if="vinAccountForm.acctType == 0">
                    <el-input v-model="uploag.businessLicenseNumber"></el-input>
                </el-form-item>
                <!-- 对公 -->
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item :label="vinAccountForm.acctType == 0 ? '法人身份证正面' : '身份证正面'" required>
                            <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                                :auto-upload="false" :on-preview="handlePictureCardPreview1" :on-change="beforeUpload1"
                                :multiple="false" :limit="1" :file-list="uploag.fileList1">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="vinAccountForm.acctType == 0 ? '法人身份证反面' : '身份证反面'" required>
                            <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                                :auto-upload="false" :on-preview="handlePictureCardPreview2" :multiple="false"
                                :limit="1" :on-change="beforeUpload2" :file-list="uploag.fileList2">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="银行卡" required>
                            <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                                :auto-upload="false" :on-preview="handlePictureCardPreview3" :multiple="false"
                                :limit="1" :on-change="beforeUpload3" :file-list="uploag.fileList3">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="vinAccountForm.acctType == 0">
                        <el-form-item label="营业执照" required>
                            <el-upload action="/api0/station-info/upLoadStationPicture" list-type="picture-card"
                                :auto-upload="false" :on-preview="handlePictureCardPreview4" :multiple="false"
                                :limit="1" :on-change="beforeUpload4" :file-list="uploag.fileList4">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-dialog :visible.sync="dialogVisible" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="editDialogClosed">取 消</el-button>
                <el-button type="success" @click="editVinAccount" :disabled="diabledTils"> 确 定</el-button>
            </span>
        </el-dialog>
        <el-row :gutter="20" style="padding-bottom: 10px">
            <el-col :span="3" label="" style="display: flex; flex-direction: row; align-items: center">
                <span style="font-size: 14px; width: 110px; padding-right: 10px">清分人</span>
                <el-select v-model="suoshudianzhan" placeholder="请选择清分人" @change="change_value" filterable>
                    <el-option v-for="item in powerStationList" :key="item.id" :label="item.merchantName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>

            <el-col :span="2">
                <el-button type="primary" icon="el-icon-search" @click="chaxun">查询</el-button>
            </el-col>
            <el-col :span="2">
                <el-button type="primary" icon="el-icon-refresh-left" @click="chongzhi">重置</el-button>
            </el-col>
            <!-- <el-col :span="2">
            <el-button type="primary" icon="el-icon-refresh-left" @click="daochu">导出</el-button>
          </el-col> -->
        </el-row>
        <!-- 卡片视图区域 直充-->
        <el-card>
            <!-- style="margin-bottom:20px ;" -->

            <li style="
            display: flex;
            justify-content: flex-end;
            margin: -10px 0 10px -1%;
          ">
            </li>
            <!-- table表格区域 -->
            <el-table :data="vinAccountList" border>
                <el-table-column align="center" label="清分人姓名" prop="trueName" width="100">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.trueName }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否主账户" prop="isMainAccount" width="100">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.isMainAccount == 0 ? '非主账户' : '主账户' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="账户类型" prop="acctType" width="100">
                    <template slot-scope="scope">
                        <!-- :style="{
                'color': scope.row.acctType == 0 ? 'red' : '#000',
            'fontWeight': scope.row.acctType == 0 ? 'bolder' : 'none',
            'fontSize': scope.row.acctType == 0 ? '26px' : '16px',
              }" -->
                        <!-- :style="stylecss(scope.row.acctType)" -->
                        <span :style="stylecss(scope.row.acctType)">
                            {{ scope.row.acctType == 0 ? '对公' : '对私' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="收款卡号" prop="bankCard" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.bankCard }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="手机号" prop="phone" width="110">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.phone }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="清分比例" prop="serviceRate" width="80">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.serviceRate + '%' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="清分金额" prop="freezeMoney" width="80">
                    <template slot-scope="scope">
                        <span> ￥{{ jisuan(scope.row.freezeMoney, 100, 2) }} </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="清分商户" prop="totalMerchantMame" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>
                            {{ typenames(scope.row.totalMerchantMame) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="登录名称" prop="userName" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>
                            {{ typenames(scope.row.userName) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="更新时间" prop="updateTime" width="100">
                    <template slot-scope="scope">
                        <span>
                            {{ typenames(scope.row.updateTime) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="操作（禁用状态下不可提现）" v-if="caozuoquanxian" width="380" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="success" icon="el-icon-plus" @click="uploadTil(scope.row)"
                            v-if="ownAcount">上传</el-button>
                        <el-button size="mini" icon="el-icon-s-help" type="danger"
                            @click="delMethods(scope.row)">删除附件</el-button>
                        <el-button size="mini" icon="el-icon-s-help" type="danger"
                            @click="delRole(scope.row)">删除清分人</el-button>

                        <!-- <el-button size="mini" v-if=""
                :type="scope.row.status == 1 ? 'success' : 'danger'" :disabled="scope.row.b_j_anniu"
                @click="stopMethods(scope.row)">{{ scope.row.status == 1 ? '启用' : '停用' }}</el-button> -->
                    </template>
                </el-table-column>
                <div slot="empty" class="empty">
                    <span>暂无数据</span>
                </div>
            </el-table>
            <!-- 分页导航区域 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.page" :page-sizes="[6, 20, 50, 100]" :page-size="queryInfo.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background>
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
import caozuo from '@/utils/pubilc.js'
const acn = [5, 11, 17, 18];
export default {
    name: 'vinAccountWorld',
    data() {
        return {
            upLoaing: false,
            dialogImageUrl: '',
            uploagRules: {
                uploadAttachName: {
                    required: true,
                    message: '请选择文件名称',
                    trigger: 'change',
                },
                bankCard: {
                    required: true,
                    message: '请输入银行卡号',
                    trigger: 'blur',
                },
                idCardNumber: {
                    required: true,
                    message: '请输入身份证号码',
                    trigger: 'blur',
                },
                businessLicenseNumber: {
                    required: true,
                    message: '请输入营业执照号码',
                    trigger: 'blur',
                },
            },
            uploag: {
                bankCard: '',
                idCardNumber: '',
                businessLicenseNumber: '',
                // file: '',
                uploadAttachContentType1: '',
                uploadAttachContentType2: "",
                uploadAttachContentType3: "",
                uploadAttachContentType4: "",
                uploadAttachType1: '',
                uploadAttachType2: '',
                uploadAttachType3: '',
                uploadAttachType4: '',
                uploadAttachName1: '',
                uploadAttachName2: '',
                uploadAttachName3: '',
                uploadAttachName4: '',
                file1: '',
                file2: '',
                file3: '',
                file4: '',
                // id: null,
                stationLedgerId: null,
            },
            diabledTils: false,
            dialogVisible: false,
            upTile: '',
            objValue: [],
            stationList: [],
            qingfenDialoag: false,
            daochuType: false,
            stopAccountStatus: false,
            StopMoney: false,
            ownAcount: false,
            btn1: false,
            kind: [
                {
                    accountKind: 57,
                    name: '对公',
                },
                {
                    accountKind: 58,
                    name: '对私',
                },
                {
                    accountKind: 56,
                    name: '支付商户',
                },
            ],
            accList: [
                {
                    acctType: 0,
                    name: '对公(金融机构开设的公司账户)',
                },
                {
                    acctType: 1,
                    name: '对私(金融机构开设的私人账户)',
                },
            ],
            centterType: [
                {
                    certType: 17,
                    name: '身份证',
                },
                {
                    certType: 18,
                    name: '护照',
                },
                {
                    certType: 19,
                    name: '港澳临时通行证',
                },
                {
                    certType: 20,
                    name: '台湾临时通行证',
                },
                {
                    certType: 22,
                    name: '港澳居民居住证',
                },
                {
                    certType: 23,
                    name: '台湾居民身份证',
                },
            ],
            leaavel: [
                {
                    isMainAccount: 0,
                    name: '否',
                },
                {
                    isMainAccount: 1,
                    name: '是',
                },
            ],
            titleDialoag: false,
            titleName: '停用',
            typings: false,
            List: [],
            coolDia: false,
            stationIds: '',
            allshanghu: [],
            typelist: [
                {
                    id: 0,
                    name: '服务费',
                },
                {
                    id: 1,
                    name: '全额消费',
                },
                // {
                //   id: 2,
                //   name: '全额电费'
                // }
            ],
            obj: {},
            powerStationList: [],
            suoshudianzhan: '',
            indexobj: {
                usingType: 0,
                billInfoType: 2,
                gunState: '0,3,4,5,6,7',
                adminId: window.sessionStorage.getItem('adminId'),
                page: 1,
                limit: 8,
                payId: '',
                userNumber: '',
                billCode: '',
                pileCode: '',
                consumeType: 0,
                type: 2,
                stationIds: window.sessionStorage.getItem('stationIds'),
                roleId: window.sessionStorage.getItem('roleId'),
            },
            DetailBtn: false,
            Detaildialoag: false,
            dialoagBtn: false,
            Moneylist: [],
            total3: 0,
            carInfo: {},
            moren: {},
            list3: [],
            listindex: 0,
            tupian: this.$imgUrls,
            listindex: 0,
            listname: [
                '查看充值记录',
                '查看退款记录',
                '查看赠送金记录',
                '查看即充即退记录',
                '查看绑定金额记录',
                '查看充电记录',
            ],
            editDialogVisible1: false,
            editDialogVisible2: false,
            caozuoquanxian: false,
            IsMainAccount: null,
            // 获取vin用户列表所需参数
            queryInfo: {
                stationId: null,
                page: 1,
                limit: 6,
                adminId: window.sessionStorage.getItem('adminId'),
                merchantName: '',
                totalLedgerId:
                    window.sessionStorage.getItem('roleId') == 1
                        ? 0
                        : window.sessionStorage.getItem('stationTotalLedgerListId'),
            },
            tilobj: {
                stationId: null,
                page: 1,
                limit: 200,
                adminId: window.sessionStorage.getItem('adminId'),
                merchantName: '',
                totalLedgerId:
                    window.sessionStorage.getItem('roleId') == 1
                        ? 0
                        : window.sessionStorage.getItem('stationTotalLedgerListId'),
            },
            radio: window.sessionStorage.getItem('roleId') == 1 ? '是' : '否',
            // vin用户数据及参数
            vinAccountList: [],
            passWord: '',
            userName: '',
            vinAccountForm: {
                passWord: '',
                userName: '',
                adminId: '',
                trueName: '',
                id: '',
                bankCard: '',
                bankName: '',
                type: '',
                serviceRate: '',
                des: '',
                isMainAccount: 1,
                freezeMoney: '',
                totalLedgerId: '',
                stationId: '',
                serviceRateStr: null,
                typeStr: null,
                bankBranchName: '',
                bankBranchNo: '',
                acctType: 1,
                certType: 17,
                accountKind: 58,
                bankNo: '',
            },
            freezeMoney: '',
            imageUrl: this.$imgUrls3,
            vinAccountFormRules: {
                trueName: {
                    required: true,
                    message: '请输入真实姓名',
                    trigger: 'blur',
                },
                // bankBranchNo: {
                //   required: true, message: '请输入联行号', trigger: 'blur'
                // },
                bankBranchName: {
                    required: true,
                    message: '请输入支行名称',
                    trigger: 'blur',
                },
                acctType: {
                    required: true,
                    message: '请选择账户类型',
                    trigger: 'change',
                },
                // accountKind: {
                //   required: true, message: '请选择账户性质', trigger: 'change'
                // },
                certType: {
                    required: true,
                    message: '请选择证件类型',
                    trigger: 'change',
                },
                merchantName: {
                    required: true,
                    message: '请输入商户名称',
                    trigger: 'blur',
                },
                phone: {
                    required: true,
                    message: '请输入联系电话',
                    trigger: 'blur',
                },
                totalLedgerId: {
                    required: true,
                    message: '请选择提现商户',
                    trigger: 'change',
                },
                // stationId: {
                //   required: true, message: '请选择所属电站', trigger: 'change'
                // },
                bankCard: {
                    required: true,
                    message: '请输入收款卡号',
                    trigger: 'blur',
                },
                bankName: {
                    required: true,
                    message: '请输入收款银行',
                    trigger: 'blur',
                },
                // userName: {
                //   required: true, message: '请输入登录账户', trigger: 'blur'
                // },
                // passWord: {
                //   required: true, message: '请输入登录密码', trigger: 'blur'
                // }
            },
            total: 0,
            title: '',
            value: '',
            ids: '',
            editDialogVisible: false,
            // 电站数据
            powerStationOptions: [],
            // 电站所属公司数据
            companyOptions: [
                {
                    value: 1,
                    label: '公交一公司',
                },
                {
                    value: 2,
                    label: '公交二公司',
                },
                {
                    value: 3,
                    label: '公交三公司',
                },
                {
                    value: 4,
                    label: '公交四公司',
                },
                {
                    value: 5,
                    label: '焦作市龙源巴士',
                },
            ],
            powerOptions: [],
            ids: '',
            currentinfo: {
                adminId: window.sessionStorage.getItem('adminId'),
                page: 1,
                limit: 100,
                id: null,
            },
            goMoneyDialoag: false,
        }
    },
    computed: {
        stylecss() {
            return (obj) => {
                const isSpecialType = obj == 0
                const obj1 = {
                    color: isSpecialType ? 'red' : '#000',
                }
                return obj1
            }
        },
        shiji() {
            return function (abc, bac) {
                return ((abc * 1 + bac * 1) / 100).toFixed(2)
            }
        },
        wait_s() {
            return function (e) {
                return ((e.money - e.giveMoney) / 100).toFixed(2)
            }
        },
        time_all() {
            return function (val) {
                const hr = val.billCode.slice(val.pileCode.length, val.billCode.length)
                return hr
            }
        },
        jisuan() {
            return function (obj, num, fixed) {
                return (obj / num).toFixed(fixed)
            }
        },
        shifu() {
            return function (val) {
                return ((val.billMoney - val.billMoneygive) / 100).toFixed(2)
            }
        },
    },
    watch: {
        passWord(newvalue) {
            if (newvalue == undefined || newvalue == '' || newvalue == null) return
            this.passWord = newvalue
        },
        userName(newvalue) {
            if (newvalue == undefined || newvalue == '' || newvalue == null) return
            this.userName = newvalue
        },
    },
    created() {
        const that = this
        that.typings = window.sessionStorage.getItem('roleId') == 1 ? true : false
        caozuo(100).then((res) => {
            that.caozuoquanxian = res
        })
        // 编辑、添加清分人员权限
        caozuo(184).then((res) => {
            that.ownAcount = res
        })
        // 冻结金额权限
        caozuo(185).then((res) => {
            that.StopMoney = res
        })
        // 修改分佣商户状态
        caozuo(186).then((res) => {
            that.stopAccountStatus = res
        })
        // 导出按钮权限
        caozuo(198).then((res) => {
            that.daochuType = res
        })
        that.stationList = []
        that.$http
            .get('station-total-ledger/getAllStationTotalLedger', {
                params: that.currentinfo,
            })
            .then((res) => {
                if (res.data.code !== 0) return
                that.allshanghu = res.data.data
            })
        that.publist()
        that.getVinAccountList()
    },
    methods: {
        typenames(obj) {
            return !obj || obj == '' ? '--' : obj;
        },
        beforeRemove() {
            return false
        },
        // 公、私
        handlePictureCardPreview1(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 公、私
        handlePictureCardPreview2(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 对公
        handlePictureCardPreview3(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 对公
        handlePictureCardPreview4(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeUpload1(file, fileList) {
            this.uploag.uploadAttachContentType1 = file.raw.type.split('image/')[1];
            this.uploag.file1 = file.raw;
            this.uploag.uploadAttachName1 = this.vinAccountForm.acctType == 0 ? '法人身份证正面' : '结算人身份证正面';
            this.uploag.uploadAttachType1 = this.vinAccountForm.acctType == 0 ? 'FR_ID_CARD_FRONT' : 'ID_CARD_FRONT';
        },
        beforeUpload2(file, fileList) {
            this.uploag.uploadAttachContentType2 = file.raw.type.split('image/')[1];
            this.uploag.file2 = file.raw;
            this.uploag.uploadAttachName2 = this.vinAccountForm.acctType == 0 ? '法人身份证反面' : '结算人身份证反面';
            this.uploag.uploadAttachType2 = this.vinAccountForm.acctType == 0 ? 'FR_ID_CARD_BEHIND' : 'ID_CARD_BEHIND';
        },
        beforeUpload3(file, fileList) {
            this.uploag.uploadAttachContentType3 = file.raw.type.split('image/')[1];
            this.uploag.file3 = file.raw;
            this.uploag.uploadAttachName3 = this.vinAccountForm.acctType == 0 ? '营业执照' : '银行卡';
            this.uploag.uploadAttachType3 = this.vinAccountForm.acctType == 0 ? 'BUSINESS_LICENCE' : 'BANK_CARD';
        },
        beforeUpload4(file, fileList) {
            this.uploag.uploadAttachContentType4 = file.raw.type.split('image/')[1];
            this.uploag.file4 = file.raw;
            this.uploag.uploadAttachName4 = '银行卡';
            this.uploag.uploadAttachType4 = 'BANK_CARD';
        },
        imageUrlMethods() {
            const fileMapping = {
                '法人身份证正面': 'fileList1',
                '结算人身份证正面': 'fileList1',
                '法人身份证反面': 'fileList2',
                '结算人身份证反面': 'fileList2',
                '银行卡': 'fileList3',
                '营业执照': 'fileList4',

            };
            if (!this.obj.stationLedgerUploadFilesList?.length) return;
            this.obj.stationLedgerUploadFilesList.forEach(item => {
                const targetFileList = fileMapping[item.uploadAttachName];
                if (targetFileList) {
                    this.uploag[targetFileList] = [{
                        name: `${item.uploadAttachName}${item.uploadAttachContentType}`,
                        url: `${this.imageUrl}${item.picImage}`
                    }];
                }
            });
        },
        editDialogClosed() {
            this.upLoaing = false;
            this.acc = [];
            this.uploag = {
                bankCard: '',
                idCardNumber: '',
                businessLicenseNumber: '',
                uploadAttachContentType1: '',
                uploadAttachContentType2: "",
                uploadAttachContentType3: "",
                uploadAttachContentType4: "",
                uploadAttachType1: '',
                uploadAttachType2: '',
                uploadAttachType3: '',
                uploadAttachType4: '',
                uploadAttachName1: '',
                uploadAttachName2: '',
                uploadAttachName3: '',
                uploadAttachName4: '',
                file1: '',
                file2: '',
                file3: '',
                file4: '',
                fileList1: [],
                fileList2: [],
                fileList3: [],
                fileList4: [],
                stationLedgerId: null,
            };

            this.diabledTils = false;
        },
        editVinAccount() {
            if (!this.uploag.bankCard || this.uploag.bankCard == '') return this.$message.error('请输入银行卡号！');
            this.uploag.bankCard = this.uploag.bankCard.replace(/\s+/g, '');
            if (!this.uploag.idCardNumber || this.uploag.idCardNumber == '') return this.$message.error('请输入身份证号码！');
            this.uploag.idCardNumber = this.uploag.idCardNumber.replace(/\s+/g, '');
            if (this.vinAccountForm.acctType == 0) {
                if (!this.uploag.businessLicenseNumber || this.uploag.businessLicenseNumber == '') return this.$message.error('请输入营业执照号码！');
                this.uploag.businessLicenseNumber = this.uploag.businessLicenseNumber.replace(/\s+/g, '');
            }
            if (this.uploag.uploadAttachName1 == '' || this.uploag.uploadAttachName2 == '' || this.uploag.uploadAttachName3 == '') return this.$message('请检查您上传的拉卡拉文件，当前信息不足！');
            this.uploag.uploadAttachName1 = this.uploag.uploadAttachName1.replace(/\s+/g, '');
            this.uploag.uploadAttachName2 = this.uploag.uploadAttachName2.replace(/\s+/g, '');
            this.uploag.uploadAttachName3 = this.uploag.uploadAttachName3.replace(/\s+/g, '');
            if (this.vinAccountForm.acctType == 0 && this.uploag.uploadAttachName4 == '') return this.$message('请检查您上传的拉卡拉文件，当前信息不足！');
            this.uploag.uploadAttachName4 = this.uploag.uploadAttachName4.replace(/\s+/g, '');
            // if (!this.obj.stationLedgerUploadFilesList || this.obj.stationLedgerUploadFilesList == '') return 
            this.$message.warning('正在上传中，请稍后...');
            this.diabledTils = true;
            this.step2();
        },
        // 添加
        step2() {
            const that = this;
            // 动态生成附件数组
            const generateAttachments = (count) => {
                return Array.from({ length: count }, (_, i) => ({
                    uploadAttachContentType: that.uploag[`uploadAttachContentType${i + 1}`],
                    file: that.uploag[`file${i + 1}`],
                    uploadAttachName: that.uploag[`uploadAttachName${i + 1}`],
                    uploadAttachType: that.uploag[`uploadAttachType${i + 1}`]
                }));
            };
            // 检查文件列表是否为空
            const shouldUploadFiles = !that.obj.stationLedgerUploadFilesList || that.obj.stationLedgerUploadFilesList === '';
            const attachmentCount = that.vinAccountForm.acctType == 0 ? 4 : 3;
            that.acc = generateAttachments(attachmentCount);
            if (!shouldUploadFiles) {
                return that.uploadFiles();
            }
            that.acc.forEach((item, index) => {
                if (that.obj[index] && item.uploadAttachName == that.obj[index].uploadAttachName) {
                    item.id = that.obj[index].id;
                }
            });
            console.log(that.acc, '384')
            that.uploadFiles()
        },
        // 编辑
        async uploadFiles() {
            try {
                const uploadPromises = this.acc.map(async (file, index) => {
                    const formData = new FormData();
                    // 添加文件特定字段
                    formData.append('uploadAttachContentType', file.uploadAttachContentType);
                    formData.append('file', file.file);
                    formData.append('uploadAttachName', file.uploadAttachName);
                    formData.append('uploadAttachType', file.uploadAttachType);
                    // 添加公共字段
                    formData.append('stationLedgerId', this.uploag.stationLedgerId);
                    formData.append('bankCard', this.uploag.bankCard);
                    formData.append('idCardNumber', this.uploag.idCardNumber);
                    formData.append('acctType', this.vinAccountForm.acctType);
                    if (this.vinAccountForm.acctType == 0) {
                        formData.append('businessLicenseNumber', this.uploag.businessLicenseNumber);
                    }
                    // 使用延迟上传，避免并发压力
                    await new Promise(resolve => setTimeout(resolve, 3000 * index));
                    const response = await this.$http.post('lkl-allowlist/upload', formData);
                    return response;
                });
                // 等待所有文件上传完成
                const results = await Promise.all(uploadPromises);
                console.log('所有文件上传完成:', results);
                // 所有文件上传成功后调用添加白名单接口
                const addResponse = await this.$http.post(
                    `lkl-allowlist/addAllowList?stationLedgerId=${this.uploag.stationLedgerId}`
                );
                // 显示结果消息
                const messageType = addResponse.data.code > 0 ? 'error' : 'success';
                this.$message({
                    type: messageType,
                    message: addResponse.data.msg
                });
                // 执行后续操作
                this.editDialogClosed();
            } catch (error) {
                console.error('上传过程出错:', error);
                this.$message({
                    type: 'error',
                    message: '文件上传失败，请重试'
                });
            }
        },
        change_value(e) {
            this.powerStationList.map((item) => {
                if (item.id !== e) return
                this.queryInfo.merchantName = item.merchantName
                console.log(window.sessionStorage.getItem('adminId'), '717')
                this.getVinAccountList()
            })
        },
        // 删除清分人
        delRole(el) {
            this.$http.get(`station-ledger/del/${el.id}/3`).then((ress) => {
                if (ress.data.code > 0) return this.$message.error('删除失败！')
                this.$message.success('删除成功！')
                this.getVinAccountList()
            })
        },
        // 删除附件
        delMethods(el) {
            const that = this
            that.$http
                .get(`station-ledger/getStationLedgerById/${el.id}`)
                .then((ress) => {
                    if (
                        !ress.data.data.stationLedgerUploadFilesList ||
                        ress.data.data.stationLedgerUploadFilesList == ''
                    )
                        return
                    const abc = ress.data.data.stationLedgerUploadFilesList
                        .map((item) => {
                            return item.id
                        })
                        .join(',')
                    that.$http
                        .post(
                            `station-ledger-upload-files/delStationLedgerUploadFiles/${abc}/${window.sessionStorage.getItem(
                                'adminId'
                            )}`
                        )
                        .then((res) => {
                            that.$message({
                                type: res.data.code > 0 ? 'error' : 'success',
                                message: res.data.msg,
                            })
                        })
                })
        },
        chaxun() {
            this.queryInfo.page = 1
            this.getVinAccountList()
        },
        uploadTil(el) {
            this.uploag.stationLedgerId = el.id;
            console.log(this.uploag.stationLedgerId);
            this.$http
                .get(
                    `station-ledger/getStationLedgerById/${this.uploag.stationLedgerId}`
                )
                .then((res) => {
                    this.vinAccountForm.acctType = res.data.data.acctType
                    this.obj = res.data.data;
                    if (!this.obj.stationLedgerUploadFilesList || this.obj.stationLedgerUploadFilesList.length == 0) return this.upLoaing = true;
                    const {
                        uploadAttachName,
                        bankCard,
                        idCardNumber,
                        businessLicenseNumber,
                        uploadAttachType,
                        // picImage,
                    } = this.obj.stationLedgerUploadFilesList[this.obj.stationLedgerUploadFilesList.length - 1];
                    this.uploag.uploadAttachName = uploadAttachName;
                    this.uploag.bankCard = bankCard;
                    this.uploag.idCardNumber = idCardNumber;
                    this.uploag.businessLicenseNumber = businessLicenseNumber;
                    this.uploag.uploadAttachType = uploadAttachType;
                    this.upLoaing = true;
                    this.imageUrlMethods()
                })
        },
        MoneyDialoag2() {
            this.dialoagBtn = false
        },
        current() {
            this.queryInfo.page = 1
        },
        chongzhi() {
            this.queryInfo = {
                // vin: '',
                companyName: '',
                carNumber: '',
                // startTime: null,
                // endTime: null,
                stationId: null,
                page: 1,
                limit: 6,
                adminId: window.sessionStorage.getItem('adminId'),
                stationIds: window.sessionStorage.getItem('stationIds'),
                roleId: window.sessionStorage.getItem('roleId'),
                totalLedgerId:
                    window.sessionStorage.getItem('roleId') == 1
                        ? 0
                        : window.sessionStorage.getItem('stationTotalLedgerListId'),
            }
            this.suoshudianzhan = ''
            this.getVinAccountList()
        },
        async publist() {
            const roleId = Number(window.sessionStorage.getItem('roleId'));
            if (!acn.includes(roleId)) {
                const { data: res } = await this.$http.get(
                    'station-ledger/getAllStationLedger',
                    { params: this.tilobj }
                )
                this.powerStationList = res.code !== 0 ? [] : res.data;
                console.log(this.powerStationList, 744)
                return;
            }
            let obj = {
                adminId: this.queryInfo.adminId,
                roleId,
                page: 1,
                limit: 10,
            }
            if (acn.includes(roleId) && roleId !== 5) {
                obj.IsMainAccount = 0
            }
            const { data: res } = await this.$http.get(
                'financial-overview/getAllStationLedger',
                {
                    params: obj,
                }
            )
            this.powerStationList = res.code !== 0 ? [] : res.data
            console.log(this.powerStationList, 763)
        },
        // 获取vin用户列表
        async getVinAccountList() {
            const roleId = Number(window.sessionStorage.getItem('roleId'));
            // let objj = this.tilobj;
            // objj.limit = 6;
            if (!acn.includes(roleId)) {
                const { data: res } = await this.$http.get(
                    'station-ledger/getAllStationLedger',
                    { params: this.queryInfo }
                )
                if (res.code !== 0) return
                this.vinAccountList = res.data;
                this.total = res.count;
                console.log(res.data, this.vinAccountList, 331)
                return;
            }
            let obj = {
                adminId: this.queryInfo.adminId,
                roleId,
                page: this.queryInfo.page,
                limit: this.queryInfo.limit,
            }
            if (acn.includes(roleId) && roleId !== 5) {
                obj.IsMainAccount = 0
            }
            const { data: res } = await this.$http.get(
                'financial-overview/getAllStationLedger',
                {
                    params: obj,
                }
            )
            if (res.code !== 0) return
            this.vinAccountList = res.data;
            console.log(res.data, this.vinAccountList, 351)
            this.total = res.count;
        },
        // 双击展开事件
        dbclick(row, column, event) {
            if (event.currentTarget.querySelector('.el-table__expand-icon')) {
                event.currentTarget.querySelector('.el-table__expand-icon').click()
            }
        },
        // 监听pageSize改变的事件
        handleSizeChange(newSize) {
            this.queryInfo.limit = newSize
            this.queryInfo.page = 1
            this.getVinAccountList()
        },
        // 监听页码值改变的事件
        handleCurrentChange(newPage) {
            this.queryInfo.page = newPage
            this.getVinAccountList()
        },
        defaultMethods() {
            const that = this
            that.title = '分佣商户'
            that.editDialogVisible = true
        }
    },
}
</script>

<style lang="less" scoped>
.titledialoag {
    width: 100%;
    height: 100%;

    p {
        display: flex;
        flex-direction: row;
        justify-content: center;
        line-height: 25px;
        color: red;
    }

    p:nth-child(3) {
        line-height: 40px;

        button {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #c5c5c5;
            font-size: 16px;
            width: 120px;
            height: 30px;
            color: #000;
        }

        button:nth-child(2) {
            margin-left: 20px;
            border: none;
            color: #fff;
            background-color: blue;
        }
    }
}

.cool {
    display: flex;
    flex-direction: column;

    p {
        display: flex;
        flex-direction: row;
        line-height: 20px;
    }

    p:nth-child(1) {
        align-items: center;

        span {
            margin-right: 10px;
        }
    }

    p:nth-child(2) {
        justify-content: center;
        align-items: center;
    }

    p:nth-child(5) {
        justify-content: center;

        button {
            width: 120px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;

            border: 1px solid #c5c5c5;
            font-size: 16px;
            border-radius: 5px;
            background: none;
        }

        button:nth-child(2) {
            margin-left: 20px;
            background: #409eff;
            border: none;
            color: #fff;
        }
    }
}

.moneylist {
    height: 180px;
    display: flex;
    flex-direction: row;

    dl {
        flex: 1;
        display: flex;
        flex-direction: column;

        p {
            flex: 1;
            display: flex;
            align-items: center;
        }
    }
}

.cardslist {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .top,
    .center {
        flex: 2;
        display: flex;
        flex-direction: column;

        dl {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            dt {
                // flex: 2;
                width: 200px;
                display: flex;
                align-items: center;
            }

            dd {
                // flex: 8
                width: calc(100% - 200px);
            }
        }
    }

    .top {
        font-size: 16px;

        dd {
            display: flex;
            flex-direction: row;

            li {
                flex: 1;
                display: flex;
                flex-direction: column;

                p {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
            }

            li:nth-child(2) {
                span:nth-child(1) {
                    width: 160px;
                }
            }
        }
    }

    .center {
        border-bottom: 1px solid gray;
        border-top: 1px solid gray;
        padding-bottom: 20px;

        dl {
            flex: 9;
        }

        dd {
            display: flex;
            flex-direction: column;

            li {
                display: flex;
                flex-direction: row;

                p {
                    margin-right: 30px;
                    display: flex;
                    flex-direction: column;

                    span:nth-child(1) {
                        font-size: 16px;
                        width: 125px;
                        color: gray;
                    }

                    span:nth-child(2) {
                        color: blue;
                        font-size: 32px;
                        display: flex;
                        margin-top: 10px;
                        justify-content: center;
                    }
                }
            }
        }

        .footername {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;

            span {
                flex: 1;
                color: blue;
            }
        }
    }

    .bottom {
        display: flex;
        flex-direction: column;
        font-size: 16px;

        h4 {
            padding: 20px 0;
        }
    }

    .center,
    .bottom.top {
        flex: 3;
    }

    .footer {
        flex: 1;
        display: flex;
        flex-direction: column;
        font-size: 16px;

        li {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            p {
                flex: 1;
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }
    }
}

.listname {
    display: flex;
    flex-direction: row;
    height: 120px;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 20px;
    border: 1px solid gray;
    list-style: none;
    border-radius: 15px;

    .dl {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-right: 20px;

        p {
            flex: 1;
            display: flex;
            justify-content: center;
            font-size: 18px;
        }

        p:nth-child(1) {
            color: gray;
            font-size: 16px;
        }
    }

    .dl:last-child {
        margin-right: 0;
    }
}
</style>